import React from 'react';

// Centred modal widths: the default one, and a compact one for short forms.
const CENTER_WIDTH_CLASS = {
    default: 'max-w-3xl',
    compact: 'max-w-[440px]',
};

const Modalstructure = ({isShowing, placement = 'center', size = 'default', onOutsideClick, children}) => {
    const widthClassName = CENTER_WIDTH_CLASS[size] ?? CENTER_WIDTH_CLASS.default;

    if (isShowing && placement === 'right') {
        return (
            <>
                {/* Slides in from the right; the backdrop closes the panel (see the portal). */}
                <div className="fixed inset-y-0 right-0 z-50 flex w-full max-w-[672px] flex-col bg-white sh-lg outline-none focus:outline-none motion-safe:animate-slideInRight">
                    {children}
                </div>
                <div className="opacity-70 fixed inset-0 z-40 bg-gray-700" onClick={onOutsideClick} aria-hidden="true"></div>
            </>
        );
    }

    return (
        <>
            {isShowing ?
                <>

                    <div className="flex fixed justify-center items-center inset-0 z-50 outline-none focus:outline-none">
                        <div className={`relative w-full ${widthClassName} my-6 mx-auto h-full py-6 overflow-y-auto no-scrollbar`}>
                            <div
                                className={`relative flex flex-col ${widthClassName} rounded-lg border-0 sh-lg bg-white outline-none focus:outline-none max-h-full overflow-y-auto`}>
                                {children}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-70 fixed inset-0 z-40 bg-gray-700"></div>
                </> : null}
        </>
    );
};

export default Modalstructure;